/* Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit } from '@angular/core';
import { GenericDialogComponent } from '../generic-dialog.component';

@Component({
	selector: 'selection-dialog',
	templateUrl: './selection-dialog.component.html',
	styleUrls: ['./selection-dialog.component.scss'],
})
export class SelectionDialogComponent extends GenericDialogComponent implements OnInit {
	public choicesGroup = this.formBuilder.group({
		choice: this.data.defaultChoice ? this.data.defaultChoice : this.data.choices[0],
	});

	public onButtonChoiceSelect() {
		this.dialogRef.close(this.choicesGroup.value.choice);
	}
}
